import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'

import {useMutation, useStore} from '../../../../../../utils/mst-hooks'
import './calendar-location-filter.scss'
import { BusinessLocationSnapshot } from '../../../../../../models/location'
import { Multiselect } from '../../../../../../components/form/multiselect/multiselect'
import { TrackedEvent, trackingService } from '../../../../../../services/tracking-service'
import {getWeekDates} from "../../../../../../utils/datetime-utils";
import moment from "moment";
import {useEffect} from "react";

function CalendarLocationFilterComponent({
  locationIds,
  setLocationIds,
    selectedDate
}: {
  locationIds: number[]
  setLocationIds: (values: number[]) => void
    selectedDate: Date
}) {
    moment.locale('en')

  const { t } = useTranslation()
  const { locationsDataView, getLocations, getLocationByName } = useStore().data

  const [locationsQueryResult, locationsQuery] = useMutation(({ hasShiftsFrom, hasShiftsTo }: { hasShiftsFrom: string, hasShiftsTo: string }) => getLocations({
      hasShiftsFrom,
      hasShiftsTo
  }))

    useEffect(() => {
        const weekDates = getWeekDates(selectedDate)
        const firstDayOfWeek = moment(weekDates[0]).format('YYYY-MM-DD')
        const lastDayOfWeek = moment(weekDates[weekDates.length - 1]).format('YYYY-MM-DD')

        locationsQuery({
            hasShiftsFrom: firstDayOfWeek,
            hasShiftsTo: lastDayOfWeek
        })
    }, [selectedDate]);

  const locationOptions =
    locationsDataView.length > 0
      ? locationsDataView.map(location => ({
          key: String(location.id),
          label: location.name,
          value: location.name,
        }))
      : []

  if (locationsQueryResult.isLoading) {
    return null
  }

  return (
    <div className="CalendarLocationFilter">
      <Multiselect
        options={locationOptions}
        className="CalendarLocationFilter__select"
        label={t('all_jobs.filter_location')}
        onChange={values => {
          trackingService.track(TrackedEvent.TimesheetLocationFilterUsed)
          setLocationIds(values.map(locationName => (getLocationByName(locationName) as BusinessLocationSnapshot).id))
        }}
      />
    </div>
  )
}

export const CalendarLocationFilter = observer(CalendarLocationFilterComponent)
